import { Method, RequestType, RETRY_CONFIG } from './http/httpConsts';

const URL = {
  LOAD_HOME: '/v2/home',
  CREATE_PIN: '/v1/consumer/pin',
  VERIFY_PIN: '/v1/consumer/mfa/pin',
  CHECKOUT: '/v2/consumer/checkout',
};

export interface RequestConfig {
  method: Method;
  /**
   * @deprecated This will be handled by react query
   */
  retryCount: number;
  type: RequestType;
  keepAlive: boolean;

  baseUrl?: string;
  image?: boolean;
}

export enum RequestName {
  LOAD_HOME = 'LOAD_HOME',
  CREATE_PIN = 'CREATE_PIN',
  VERIFY_PIN = 'VERIFY_PIN',
}

export const API_CONFIG: Record<RequestName, RequestConfig> = {
  LOAD_HOME: {
    baseUrl: URL.LOAD_HOME,
    method: Method.GET,
    retryCount: RETRY_CONFIG[Method.GET],
    type: RequestType.INTERNAL,
    keepAlive: false,
  },
  CREATE_PIN: {
    baseUrl: URL.CREATE_PIN,
    method: Method.POST,
    retryCount: RETRY_CONFIG[Method.POST],
    type: RequestType.INTERNAL,
    keepAlive: false,
  },
  VERIFY_PIN: {
    baseUrl: URL.VERIFY_PIN,
    method: Method.POST,
    retryCount: RETRY_CONFIG[Method.POST],
    type: RequestType.INTERNAL,
    keepAlive: false,
  },
};
